// Module
var code = "<div id=\"V-DFB7AC79-744D-46B8-806A-B4557212426E\"> <div data-b-component=\"dragdrop\" data-b-comp-allowdropinto=\"true\"> <div data-b-content=\"{Binding decoratorComponent,ViewSelector:getCompactViewForFormBuilderStructureViewDecorators}\"> </div> </div> </div> ";
// Exports
export default code;